module.exports = __webpack_public_path__ + "img/photos/avatars/03.jpg";